import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationPT from './locales/pt.json';
import translationPTBR from './locales/pt-BR.json';
import translationEN from './locales/en.json';
import translationES from './locales/es.json';

/**
 * 🇵🇹 KETO LAB - CONFIGURAÇÃO DE IDIOMAS
 * =====================================
 * IDIOMA NATIVO: Português (Portugal) - pt
 * Idiomas suportados: pt (padrão), pt-BR, en, es
 * 
 * A APP é nativa em Português!
 * 
 * MERCADOS:
 * - PT: Portugal (nativo)
 * - PT-BR: Brasil
 * - EN: Internacional (UK, US, AU)
 * - ES: Espanha, América Latina
 */

// Obter idioma guardado ou usar PT como padrão
const getSavedLanguage = () => {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem('language');
    // Validar se é um idioma suportado
    if (saved && ['pt', 'pt-BR', 'en', 'es'].includes(saved)) {
      return saved;
    }
  }
  return 'pt'; // PORTUGUÊS É O IDIOMA NATIVO/PADRÃO
};

const savedLanguage = getSavedLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      pt: {
        translation: translationPT
      },
      'pt-BR': {
        translation: translationPTBR
      },
      en: {
        translation: translationEN
      },
      es: {
        translation: translationES
      }
    },
    lng: savedLanguage,           // Idioma atual (guardado ou pt)
    fallbackLng: 'pt',            // Fallback é PORTUGUÊS SEMPRE
    supportedLngs: ['pt', 'pt-BR', 'en', 'es'],
    load: 'currentOnly',          // Não carregar variantes
    interpolation: {
      escapeValue: false
    },
    detection: {
      // PRIORIZAR localStorage - Só usar navigator se utilizador escolheu
      order: ['localStorage'],
      caches: ['localStorage'],
      // NÃO detectar do navigator automaticamente
      lookupLocalStorage: 'language'
    }
  });

// Guardar idioma no localStorage quando mudar
i18n.on('languageChanged', (lng) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('language', lng);
    console.log(`🌍 Idioma alterado para: ${lng}`);
  }
});

export default i18n;
